import React from 'react'
import styles from './SPEssential.module.css'

const SPEssential = () => {
    return (
        <div>SPEssential</div>
    )
}

export default SPEssential